module.exports = __webpack_public_path__ + "img/mar.ia-secondary.fb0543cc.svg";